/**
 * Safely serializes unknown error types for logging with pino
 * Handles Error objects, strings, and other types gracefully
 */
export function serializeError(error: unknown): string {
    if (error instanceof Error) {
        return error.message;
    }
    if (typeof error === 'string') {
        return error;
    }
    try {
        return JSON.stringify(error);
    } catch {
        return String(error);
    }
}

/**
 * Serializes error with full details including stack trace
 * Useful for detailed debugging scenarios
 */
export function serializeErrorFull(error: unknown): Record<string, unknown> {
    if (error instanceof Error) {
        return {
            message: error.message,
            name: error.name,
            stack: error.stack,
            ...(error.cause ? { cause: serializeError(error.cause) } : {}),
        };
    }
    return { value: String(error) };
}
